import spritemap from '../images/icons.svg';

export default spritemap;